<div class="patrol-profile-page">
  <div class="page-header">
    <h1 class="page-title">{{ 'app.patrol.profile.title' | translate }}</h1>
    <p class="page-subtitle">{{ 'app.patrol.profile.subtitle' | translate }}</p>
  </div>

  <section class="profile-section">
    <app-personal-data-editor
      [user]="patrolUser()"
      [layout]="'patrol'"
    />
  </section>
</div>
